import { Link } from "@tanstack/react-router";

/**
 * Two short passages instead of a four-icon "why trust us" grid: what alpha-gal
 * syndrome is (the reason most people should care about this tick at all), and how the
 * guide is put together. Every claim in the first is on /alpha-gal with its sources.
 */
export function HomeTrust() {
  return (
    <section className="border-y border-border bg-paper-deep">
      <div className="mx-auto grid max-w-6xl gap-x-14 gap-y-12 px-4 py-16 sm:px-6 lg:grid-cols-2">
        <article aria-labelledby="home-alpha-gal">
          <h2 className="label-caps text-rust-ink" id="home-alpha-gal">
            Why this tick matters
          </h2>
          <p className="mt-4 font-display text-[1.75rem] font-medium leading-[1.2] text-foreground sm:text-[2rem]">
            A Lone Star tick bite can leave some people allergic to red meat.
          </p>
          <div className="measure mt-5 space-y-3 text-[0.9375rem] leading-relaxed text-muted-foreground">
            <p>
              It&rsquo;s called alpha-gal syndrome. The reaction usually comes about 2–6 hours after
              eating beef, pork, lamb or venison, which is why it is so often missed. Most people
              who are bitten never get it.
            </p>
            <p>
              <Link to="/alpha-gal" className="link font-semibold">
                What alpha-gal syndrome is, and how it&rsquo;s diagnosed
              </Link>
            </p>
          </div>
        </article>

        <article aria-labelledby="home-method">
          <h2 className="label-caps text-muted-foreground" id="home-method">
            How this guide is made
          </h2>
          <dl className="mt-4 divide-y divide-border border-y border-border">
            {[
              [
                "Sourced",
                "Each state lists the CDC surveillance and research it is based on, so you can check it.",
              ],
              [
                "Honest about gaps",
                "Where public data is thin, the page says so instead of guessing a number.",
              ],
              [
                "Private",
                "No account and no ads. Anything you save, like a bite log, stays on your device.",
              ],
              ["Free", "Built entirely from public data, so there is nothing to charge for."],
            ].map(([term, body]) => (
              <div key={term} className="grid gap-1 py-3.5 sm:grid-cols-[10rem_1fr] sm:gap-4">
                <dt className="font-display text-lg text-foreground">{term}</dt>
                <dd className="text-[0.9375rem] leading-relaxed text-muted-foreground">{body}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-4 text-sm text-muted-foreground">
            <Link to="/sources" className="link">
              Every source
            </Link>{" "}
            ·{" "}
            <Link to="/about" className="link">
              About this guide
            </Link>
          </p>
        </article>
      </div>
    </section>
  );
}
